// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../../domain/store/AuthStore.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as SignupWhatsappConsentV2ModuleScss from "../../../styles/SignupWhatsappConsentV2.module.scss";

var styles = SignupWhatsappConsentV2ModuleScss;

function SignupWhatsappConsentCmpV2(Props) {
  var consent = Props.consent;
  var set_consent = Props.set_consent;
  var router = Router.useRouter();
  return React.createElement("div", {
              className: styles["whatsapp-consent-wrapper"]
            }, React.createElement("div", {
                  className: styles.switch,
                  onClick: (function (param) {
                      if (consent) {
                        PublishEventsHelper$PorterinFeature.publishEvents(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.Signup.ga_whatsapp_consent_true, undefined);
                      } else {
                        PublishEventsHelper$PorterinFeature.publishEvents(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.Signup.ga_whatsapp_consent_false, undefined);
                      }
                      Curry._1(set_consent, (function (param) {
                              return !consent;
                            }));
                    })
                }, React.createElement("label", {
                      className: "checkbox"
                    }, React.createElement("input", {
                          checked: consent,
                          name: "whatspp-consent",
                          type: "checkbox"
                        }), React.createElement("label", {
                          className: "checkmark"
                        }))), React.createElement("p", {
                  className: styles.text
                }, AuthStore$PorterinFeature.SignupV2.whatsapp_consent));
}

var make = SignupWhatsappConsentCmpV2;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
